import apiClient from "../lib/api-client";

export interface Manufacturer {
  id: string;
  tenantId: string;
  manufacturerCode: string;
  manufacturerName: string;
  shortName?: string;
  licenseNumber?: string;
  licenseExpiry?: string;
  address?: string;
  city?: string;
  state?: string;
  pincode?: string;
  country?: string;
  phone?: string;
  email?: string;
  website?: string;
  gstNumber?: string;
  panNumber?: string;
  qualityRating?: number;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
  _count?: {
    products: number;
  };
}

export interface CreateManufacturerDto {
  manufacturerCode: string;
  manufacturerName: string;
  shortName?: string;
  licenseNumber?: string;
  licenseExpiry?: string;
  address?: string;
  city?: string;
  state?: string;
  pincode?: string;
  country?: string;
  phone?: string;
  email?: string;
  website?: string;
  gstNumber?: string;
  panNumber?: string;
  qualityRating?: number;
}

export interface UpdateManufacturerDto extends Partial<CreateManufacturerDto> {
  isActive?: boolean;
}

export interface ManufacturerListResponse {
  data: Manufacturer[];
  pagination: {
    total: number;
    page: number;
    limit: number;
    totalPages: number;
  };
}

export const manufacturerService = {
  async getAll(params?: {
    page?: number;
    limit?: number;
    search?: string;
    isActive?: boolean;
  }): Promise<ManufacturerListResponse> {
    const searchParams = new URLSearchParams();
    if (params?.page) searchParams.append("page", params.page.toString());
    if (params?.limit) searchParams.append("limit", params.limit.toString());
    if (params?.search) searchParams.append("search", params.search);
    if (params?.isActive !== undefined)
      searchParams.append("isActive", params.isActive.toString());

    const response = await apiClient.get(`/manufacturers?${searchParams}`);
    return response.data;
  },

  async getById(id: string): Promise<Manufacturer> {
    const response = await apiClient.get(`/manufacturers/${id}`);
    return response.data;
  },

  async create(data: CreateManufacturerDto): Promise<Manufacturer> {
    const response = await apiClient.post("/manufacturers", data, {
      headers: { "Idempotency-Key": crypto.randomUUID() },
    });
    return response.data;
  },

  async update(id: string, data: UpdateManufacturerDto): Promise<Manufacturer> {
    const response = await apiClient.patch(`/manufacturers/${id}`, data, {
      headers: { "Idempotency-Key": crypto.randomUUID() },
    });
    return response.data;
  },

  async delete(id: string): Promise<void> {
    await apiClient.delete(`/manufacturers/${id}`, {
      headers: { "Idempotency-Key": crypto.randomUUID() },
    });
  },
};
